// DropdownButton.jsx
import React from "react";
import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";

const Drop = ({ items = [], label = "Select", onMenuClick }) => {
    const menuProps = {
        items,
        onClick: onMenuClick,
    };

    return (
        <Dropdown menu={menuProps} placement="bottom" className="dropdown-class">
            <Button>
                <Space>
                    {label}
                    <DownOutlined  />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default Drop;
